import { connect } from "react-redux";
import CategoryHeaderLinks from "./CategoryHeaderLinks";
import { getCategorySeoLinks } from "../../../../../../state/modules/category/selectors";

const mapStateToProps = state => {
  const { primarySeoLinks } = getCategorySeoLinks(state);

  return { links: primarySeoLinks };
};

export default connect(mapStateToProps)(CategoryHeaderLinks);
